(function () {
  "use strict";

  // ── Helpers ──────────────────────────────────────────
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === "className") node.className = attrs[k];
        else if (k === "textContent") node.textContent = attrs[k];
        else if (k === "innerHTML") node.innerHTML = attrs[k];
        else if (k.startsWith("on")) node.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (typeof c === "string") node.appendChild(document.createTextNode(c));
        else if (c) node.appendChild(c);
      });
    }
    return node;
  }

  function starSVG(filled, color) {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "16");
    svg.setAttribute("height", "16");
    svg.style.display = "inline-block";
    svg.style.verticalAlign = "middle";
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z");
    path.setAttribute("fill", filled ? (color || "#F59E0B") : "none");
    path.setAttribute("stroke", color || "#F59E0B");
    path.setAttribute("stroke-width", "1.5");
    path.setAttribute("stroke-linejoin", "round");
    svg.appendChild(path);
    return svg;
  }

  function renderStars(rating, color, size) {
    var wrap = el("span", { className: "rf-stars-wrap" });
    wrap.style.display = "inline-flex";
    wrap.style.gap = "2px";
    wrap.style.alignItems = "center";
    for (var i = 1; i <= 5; i++) {
      var s = starSVG(i <= Math.round(rating), color);
      if (size) { s.setAttribute("width", size); s.setAttribute("height", size); }
      wrap.appendChild(s);
    }
    return wrap;
  }

  function timeAgo(dateStr) {
    var d = new Date(dateStr);
    var now = new Date();
    var diff = Math.floor((now - d) / 1000);
    if (diff < 60) return "just now";
    if (diff < 3600) return Math.floor(diff / 60) + "m ago";
    if (diff < 86400) return Math.floor(diff / 3600) + "h ago";
    if (diff < 2592000) return Math.floor(diff / 86400) + "d ago";
    return d.toLocaleDateString();
  }

  // ── Lightbox ───────────────────────────────────────
  var lightboxEl = null;

  function openLightbox(src, alt) {
    if (lightboxEl) closeLightbox();
    lightboxEl = el("div", { className: "rf-lightbox" });
    var backdrop = el("div", { className: "rf-lightbox__backdrop", onClick: closeLightbox });
    var closeBtn = el("button", {
      className: "rf-lightbox__close",
      textContent: "\u00D7",
      onClick: closeLightbox,
      "aria-label": "Close lightbox"
    });
    var img = el("img", {
      className: "rf-lightbox__img",
      src: src,
      alt: alt || "Review photo"
    });
    lightboxEl.appendChild(backdrop);
    lightboxEl.appendChild(closeBtn);
    lightboxEl.appendChild(img);
    document.body.appendChild(lightboxEl);
    document.addEventListener("keydown", lightboxKeyHandler);
  }

  function closeLightbox() {
    if (lightboxEl) {
      lightboxEl.remove();
      lightboxEl = null;
    }
    document.removeEventListener("keydown", lightboxKeyHandler);
  }

  function lightboxKeyHandler(e) {
    if (e.key === "Escape") closeLightbox();
  }

  // ── Helpful vote localStorage helper ───────────────
  function getHelpfulVotes() {
    try {
      return JSON.parse(localStorage.getItem("rf_helpful_votes") || "{}");
    } catch (e) {
      return {};
    }
  }

  function markHelpfulVoted(reviewId) {
    var votes = getHelpfulVotes();
    votes[reviewId] = true;
    try {
      localStorage.setItem("rf_helpful_votes", JSON.stringify(votes));
    } catch (e) { /* storage full, ignore */ }
  }

  function hasVotedHelpful(reviewId) {
    return !!getHelpfulVotes()[reviewId];
  }

  // ── Star Badge (product cards) ──────────────────────
  function initBadges() {
    var badges = document.querySelectorAll(".rf-star-badge");
    if (!badges.length) return;

    // Group badges by shop+productId and batch fetch
    var byKey = {};
    badges.forEach(function (badge) {
      var proxyUrl = badge.getAttribute("data-proxy-url");
      var productId = badge.getAttribute("data-product-id");
      var productHandle = badge.getAttribute("data-product-handle") || "";
      var shop = badge.getAttribute("data-shop");
      var contentType = badge.getAttribute("data-content-type") || "product";
      if (!proxyUrl || !productId) return;
      var key = proxyUrl + "|" + productId + "|" + contentType;
      if (!byKey[key]) byKey[key] = { proxyUrl: proxyUrl, productId: productId, productHandle: productHandle, shop: shop, contentType: contentType, badges: [] };
      byKey[key].badges.push(badge);
    });

    Object.keys(byKey).forEach(function (key) {
      var info = byKey[key];
      var url = info.proxyUrl + "?productId=" + encodeURIComponent(info.productId) + "&page=1";
      if (info.productHandle) {
        url += "&productHandle=" + encodeURIComponent(info.productHandle);
      }
      if (info.contentType && info.contentType !== "product") {
        url += "&contentType=" + encodeURIComponent(info.contentType);
      }

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          info.badges.forEach(function (badge) {
            var color = badge.getAttribute("data-star-color") || "#F59E0B";
            var starsEl = badge.querySelector(".rf-stars");
            var countEl = badge.querySelector(".rf-count");

            if (starsEl) {
              starsEl.innerHTML = "";
              starsEl.appendChild(renderStars(data.averageRating || 0, color, "14"));
            }
            if (countEl) {
              countEl.textContent = data.totalCount > 0
                ? "(" + data.totalCount + ")"
                : "No reviews";
              countEl.style.fontSize = "0.8rem";
              countEl.style.color = "#666";
              countEl.style.marginLeft = "4px";
            }
          });
        })
        .catch(function () { /* silent fail for badges */ });
    });
  }

  // ── Full Review Widget (product page) ───────────────
  function initWidget() {
    var root = document.getElementById("reviewflow-widget");
    if (!root) return;

    var proxyUrl = root.getAttribute("data-proxy-url");
    var productId = root.getAttribute("data-product-id");
    var productHandle = root.getAttribute("data-product-handle") || "";
    var productTitle = root.getAttribute("data-product-title") || "";
    var shop = root.getAttribute("data-shop");
    var customerEmail = root.getAttribute("data-customer-email") || "";
    var customerName = root.getAttribute("data-customer-name") || "";
    var starColor = root.getAttribute("data-star-color") || "#F59E0B";
    var contentType = root.getAttribute("data-content-type") || "product";
    var perPage = parseInt(root.getAttribute("data-per-page") || "10", 10);
    var layout = root.getAttribute("data-layout") || "list";
    var cardsPerView = parseInt(root.getAttribute("data-cards-per-view") || "2", 10);
    var autoRotate = root.getAttribute("data-auto-rotate") === "true";
    var rotateSpeed = parseInt(root.getAttribute("data-rotate-speed") || "5", 10) * 1000;
    var photoUploadEnabled = root.getAttribute("data-photo-upload") === "true";

    var currentPage = 1;
    var currentSort = "newest";
    var currentFilter = "all"; // "all", "photos", "5", "4", "3", "2", "1"
    var starsRow; // reference for form star picker
    var selectedFiles = []; // files selected for photo upload

    function buildFetchUrl(page) {
      var url = proxyUrl + "?productId=" + encodeURIComponent(productId) + "&page=" + page;
      if (productHandle) {
        url += "&productHandle=" + encodeURIComponent(productHandle);
      }
      if (contentType && contentType !== "product") {
        url += "&contentType=" + encodeURIComponent(contentType);
      }
      url += "&sort=" + encodeURIComponent(currentSort);
      if (currentFilter === "photos") {
        url += "&hasPhotos=true";
      } else if (currentFilter >= "1" && currentFilter <= "5") {
        url += "&rating=" + currentFilter;
      }
      return url;
    }

    function loadReviews(page) {
      var url = buildFetchUrl(page);
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          root.innerHTML = "";
          root.appendChild(buildWidget(data, page));
          injectSEO(data);
        })
        .catch(function () {
          root.innerHTML = "";
          root.appendChild(el("p", { textContent: "Unable to load reviews." }));
        });
    }

    function buildWidget(data, page) {
      var widgetClass = "rf-widget" + (layout === "carousel" ? " rf-widget--carousel" : "");
      var container = el("div", { className: widgetClass });

      // Title
      var widgetTitle = contentType === "recipe" ? "Recipe Reviews" : "Customer Reviews";
      container.appendChild(el("h2", { className: "rf-widget__title", textContent: widgetTitle }));

      // Summary
      var summary = el("div", { className: "rf-widget__summary" });

      // Left: big rating number + stars
      var summaryLeft = el("div", { className: "rf-widget__summary-left" });
      summaryLeft.appendChild(el("div", { className: "rf-widget__avg-rating", textContent: (data.averageRating || 0).toFixed(1) }));
      summaryLeft.appendChild(renderStars(data.averageRating || 0, starColor, "20"));
      summaryLeft.appendChild(el("div", {
        className: "rf-widget__total",
        textContent: data.totalCount + " review" + (data.totalCount !== 1 ? "s" : "")
      }));
      summary.appendChild(summaryLeft);

      // Right: rating distribution bars
      var summaryRight = el("div", { className: "rf-widget__distribution" });
      for (var star = 5; star >= 1; star--) {
        var count = (data.ratingDistribution && data.ratingDistribution[star]) || 0;
        var pct = data.totalCount > 0 ? Math.round((count / data.totalCount) * 100) : 0;
        var row = el("div", { className: "rf-widget__dist-row" });
        row.appendChild(el("span", { className: "rf-widget__dist-label", textContent: star + "\u2605" }));
        var bar = el("div", { className: "rf-widget__dist-bar" });
        var fill = el("div", { className: "rf-widget__dist-fill" });
        fill.style.width = pct + "%";
        fill.style.backgroundColor = starColor;
        bar.appendChild(fill);
        row.appendChild(bar);
        row.appendChild(el("span", { className: "rf-widget__dist-count", textContent: count }));
        summaryRight.appendChild(row);
      }
      summary.appendChild(summaryRight);
      container.appendChild(summary);

      // Write a Review button
      var writeBtn = el("button", {
        className: "rf-widget__write-btn",
        textContent: "Write a Review",
        onClick: function () { toggleForm(); }
      });
      writeBtn.style.backgroundColor = starColor;
      container.appendChild(writeBtn);

      // Review Form (hidden by default)
      var formWrap = el("div", { className: "rf-widget__form-wrap", id: "rf-form-wrap" });
      formWrap.style.display = "none";
      formWrap.appendChild(buildForm());
      container.appendChild(formWrap);

      // ── Controls bar: Filter tabs + Sort dropdown ──
      var controls = el("div", { className: "rf-widget__controls" });

      // Filter tabs
      var filters = el("div", { className: "rf-widget__filters" });
      var filterOptions = [
        { label: "All", value: "all" },
        { label: "With Photos", value: "photos" },
        { label: "5\u2605", value: "5" },
        { label: "4\u2605", value: "4" },
        { label: "3\u2605", value: "3" },
        { label: "2\u2605", value: "2" },
        { label: "1\u2605", value: "1" }
      ];
      filterOptions.forEach(function (opt) {
        var btnClass = "rf-widget__filter-btn";
        if (currentFilter === opt.value) btnClass += " rf-widget__filter-btn--active";
        var btn = el("button", {
          className: btnClass,
          textContent: opt.label,
          "data-filter": opt.value,
          onClick: function () {
            currentFilter = opt.value;
            currentPage = 1;
            loadReviews(1);
          }
        });
        if (currentFilter === opt.value) {
          btn.style.backgroundColor = starColor;
          btn.style.borderColor = starColor;
        }
        filters.appendChild(btn);
      });
      controls.appendChild(filters);

      // Sort dropdown
      var sortWrap = el("div", { className: "rf-widget__sort" });
      sortWrap.appendChild(el("label", { className: "rf-widget__sort-label", textContent: "Sort by: ", "for": "rf-sort-select" }));
      var sortSelect = el("select", { className: "rf-widget__sort-select", id: "rf-sort-select" });
      var sortOptions = [
        { label: "Most Recent", value: "newest" },
        { label: "Oldest First", value: "oldest" },
        { label: "Highest Rated", value: "highest" },
        { label: "Lowest Rated", value: "lowest" },
        { label: "Most Helpful", value: "helpful" }
      ];
      sortOptions.forEach(function (opt) {
        var option = el("option", { value: opt.value, textContent: opt.label });
        if (opt.value === currentSort) option.selected = true;
        sortSelect.appendChild(option);
      });
      sortSelect.addEventListener("change", function () {
        currentSort = sortSelect.value;
        currentPage = 1;
        loadReviews(1);
      });
      sortWrap.appendChild(sortSelect);
      controls.appendChild(sortWrap);

      container.appendChild(controls);

      // Review List — render based on layout mode
      var hasReviews = data.reviews && data.reviews.length > 0;
      var emptyMsg = currentFilter !== "all"
        ? "No reviews match this filter."
        : "No reviews yet. Be the first to write one!";

      if (layout === "carousel") {
        container.appendChild(buildCarousel(data.reviews || [], emptyMsg, hasReviews));
      } else if (layout === "grid") {
        var grid = el("div", { className: "rf-widget__grid" });
        grid.style.gridTemplateColumns = "repeat(" + cardsPerView + ", 1fr)";
        if (hasReviews) {
          data.reviews.forEach(function (review) {
            grid.appendChild(buildReviewCard(review));
          });
        } else {
          grid.appendChild(el("p", { className: "rf-widget__empty", textContent: emptyMsg }));
        }
        container.appendChild(grid);
      } else if (layout === "compact") {
        var compactList = el("div", { className: "rf-widget__compact" });
        if (hasReviews) {
          data.reviews.forEach(function (review) {
            compactList.appendChild(buildCompactCard(review));
          });
        } else {
          compactList.appendChild(el("p", { className: "rf-widget__empty", textContent: emptyMsg }));
        }
        container.appendChild(compactList);
      } else {
        // Default: list
        var list = el("div", { className: "rf-widget__list" });
        if (hasReviews) {
          data.reviews.forEach(function (review) {
            list.appendChild(buildReviewCard(review));
          });
        } else {
          list.appendChild(el("p", { className: "rf-widget__empty", textContent: emptyMsg }));
        }
        container.appendChild(list);
      }

      // Pagination (not shown in carousel mode — it uses arrows instead)
      if (layout !== "carousel") {
        var pagesTotal = data.totalPages || 1;
        if (pagesTotal > 1) {
          var pag = el("div", { className: "rf-widget__pagination" });
          if (page > 1) {
            pag.appendChild(el("button", {
              className: "rf-widget__page-btn",
              textContent: "\u2190 Previous",
              onClick: function () { currentPage--; loadReviews(currentPage); }
            }));
          }
          pag.appendChild(el("span", { textContent: "Page " + page + " of " + pagesTotal }));
          if (page < pagesTotal) {
            pag.appendChild(el("button", {
              className: "rf-widget__page-btn",
              textContent: "Next \u2192",
              onClick: function () { currentPage++; loadReviews(currentPage); }
            }));
          }
          container.appendChild(pag);
        }
      }

      return container;
    }

    function buildReviewCard(review) {
      var card = el("div", { className: "rf-review-card" });

      var header = el("div", { className: "rf-review-card__header" });
      header.appendChild(renderStars(review.rating, starColor, "16"));
      if (review.verifiedBuyer && contentType !== "recipe") {
        var badge = el("span", { className: "rf-review-card__verified", textContent: "\u2713 Verified Buyer" });
        header.appendChild(badge);
      }
      card.appendChild(header);

      if (review.title) {
        card.appendChild(el("div", { className: "rf-review-card__title", textContent: review.title }));
      }

      // Body with expand/collapse for long reviews
      var BODY_LIMIT = 200;
      var bodyText = review.body || "";
      var isLong = bodyText.length > BODY_LIMIT;
      var bodyEl = el("div", { className: "rf-review-card__body" });

      if (isLong) {
        var truncated = bodyText.substring(0, BODY_LIMIT) + "…";
        bodyEl.textContent = truncated;
        bodyEl.className = "rf-review-card__body rf-review-card__body--truncated";
        var toggleLink = el("button", {
          className: "rf-review-card__toggle",
          textContent: "Read more",
          onClick: function () {
            var expanded = bodyEl.getAttribute("data-expanded") === "true";
            if (expanded) {
              bodyEl.textContent = truncated;
              bodyEl.appendChild(toggleLink);
              bodyEl.setAttribute("data-expanded", "false");
              bodyEl.className = "rf-review-card__body rf-review-card__body--truncated";
              toggleLink.textContent = "Read more";
            } else {
              bodyEl.textContent = bodyText;
              bodyEl.appendChild(toggleLink);
              bodyEl.setAttribute("data-expanded", "true");
              bodyEl.className = "rf-review-card__body rf-review-card__body--expanded";
              toggleLink.textContent = "Read less";
            }
          }
        });
        bodyEl.appendChild(toggleLink);
        bodyEl.setAttribute("data-expanded", "false");
      } else {
        bodyEl.textContent = bodyText;
      }
      card.appendChild(bodyEl);

      // Media with lightbox
      if (review.media && review.media.length > 0) {
        var mediaWrap = el("div", { className: "rf-review-card__media" });
        review.media.forEach(function (m) {
          if (m.type === "image") {
            var img = el("img", {
              className: "rf-review-card__img",
              src: m.url,
              alt: m.altText || "Review photo",
              loading: "lazy",
              onClick: function () {
                openLightbox(m.url, m.altText || "Review photo");
              }
            });
            mediaWrap.appendChild(img);
          }
        });
        card.appendChild(mediaWrap);
      }

      var footer = el("div", { className: "rf-review-card__footer" });
      var footerLeft = el("div", { className: "rf-review-card__footer-left" });
      footerLeft.appendChild(el("span", { className: "rf-review-card__author", textContent: review.customerName }));
      footerLeft.appendChild(el("span", { className: "rf-review-card__date", textContent: timeAgo(review.createdAt) }));
      footer.appendChild(footerLeft);

      // Helpful button
      var voted = hasVotedHelpful(review.id);
      var helpfulCount = review.helpfulCount || 0;
      var helpfulClass = "rf-review-card__helpful" + (voted ? " rf-review-card__helpful--voted" : "");
      var helpfulBtn = el("button", {
        className: helpfulClass,
        textContent: "Helpful (" + helpfulCount + ")",
        onClick: function () {
          if (hasVotedHelpful(review.id)) return;
          var fd = new FormData();
          fd.append("intent", "helpful");
          fd.append("reviewId", review.id);
          fetch(proxyUrl, { method: "POST", body: fd })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.success) {
                markHelpfulVoted(review.id);
                helpfulBtn.textContent = "Helpful (" + data.helpfulCount + ")";
                helpfulBtn.className = "rf-review-card__helpful rf-review-card__helpful--voted";
              }
            })
            .catch(function () { /* silent fail */ });
        }
      });
      if (voted) helpfulBtn.disabled = true;
      footer.appendChild(helpfulBtn);

      card.appendChild(footer);

      // Admin reply
      if (review.replyBody) {
        var reply = el("div", { className: "rf-review-card__reply" });
        reply.appendChild(el("div", { className: "rf-review-card__reply-label", textContent: "Store Response:" }));
        reply.appendChild(el("div", { textContent: review.replyBody }));
        card.appendChild(reply);
      }

      return card;
    }

    // ── Carousel layout ─────────────────────────────────
    function buildCarousel(reviews, emptyMsg, hasReviews) {
      var wrapper = el("div", { className: "rf-carousel" });
      if (!hasReviews) {
        wrapper.appendChild(el("p", { className: "rf-widget__empty", textContent: emptyMsg }));
        return wrapper;
      }

      var track = el("div", { className: "rf-carousel__track" });
      var slideIndex = 0;
      var totalSlides = reviews.length;
      var visibleCards;

      function getVisibleCards() {
        return window.innerWidth <= 600 ? 1 : cardsPerView;
      }

      reviews.forEach(function (review) {
        var slide = el("div", { className: "rf-carousel__slide" });
        slide.appendChild(buildReviewCard(review));
        track.appendChild(slide);
      });

      var viewport = el("div", { className: "rf-carousel__viewport" });
      viewport.appendChild(track);

      // Navigation arrows
      var prevBtn = el("button", {
        className: "rf-carousel__arrow rf-carousel__arrow--prev",
        innerHTML: "&#8249;",
        "aria-label": "Previous reviews",
        onClick: function () {
          slideIndex = Math.max(0, slideIndex - visibleCards);
          updateCarousel();
        }
      });
      var nextBtn = el("button", {
        className: "rf-carousel__arrow rf-carousel__arrow--next",
        innerHTML: "&#8250;",
        "aria-label": "Next reviews",
        onClick: function () {
          var maxIndex = Math.max(0, totalSlides - visibleCards);
          slideIndex = Math.min(maxIndex, slideIndex + visibleCards);
          updateCarousel();
        }
      });

      // Dots indicator
      var dotsWrap = el("div", { className: "rf-carousel__dots" });
      var numPages = Math.ceil(totalSlides / visibleCards);
      for (var d = 0; d < numPages; d++) {
        (function (pageIdx) {
          var dot = el("button", {
            className: "rf-carousel__dot" + (pageIdx === 0 ? " rf-carousel__dot--active" : ""),
            "aria-label": "Go to page " + (pageIdx + 1),
            onClick: function () {
              slideIndex = pageIdx * visibleCards;
              updateCarousel();
            }
          });
          dotsWrap.appendChild(dot);
        })(d);
      }

      function updateCarousel() {
        visibleCards = getVisibleCards();
        // Update slide widths to match current visibleCards
        track.querySelectorAll(".rf-carousel__slide").forEach(function (slide) {
          slide.style.width = (100 / visibleCards) + "%";
          slide.style.flex = "0 0 " + (100 / visibleCards) + "%";
        });
        var slideWidth = 100 / visibleCards;
        var offset = slideIndex * slideWidth;
        track.style.transform = "translateX(-" + offset + "%)";
        // Update arrow states
        prevBtn.style.opacity = slideIndex === 0 ? "0.3" : "1";
        prevBtn.style.pointerEvents = slideIndex === 0 ? "none" : "auto";
        var maxIndex = Math.max(0, totalSlides - visibleCards);
        nextBtn.style.opacity = slideIndex >= maxIndex ? "0.3" : "1";
        nextBtn.style.pointerEvents = slideIndex >= maxIndex ? "none" : "auto";
        // Update dots
        var currentPage = Math.floor(slideIndex / visibleCards);
        dotsWrap.querySelectorAll(".rf-carousel__dot").forEach(function (dot, idx) {
          dot.className = "rf-carousel__dot" + (idx === currentPage ? " rf-carousel__dot--active" : "");
        });
      }

      wrapper.appendChild(prevBtn);
      wrapper.appendChild(viewport);
      wrapper.appendChild(nextBtn);
      wrapper.appendChild(dotsWrap);

      // Initial state
      setTimeout(function () { updateCarousel(); }, 0);

      // Auto-rotate
      var autoTimer = null;
      function startAutoRotate() {
        if (!autoRotate) return;
        stopAutoRotate();
        autoTimer = setInterval(function () {
          var maxIndex = Math.max(0, totalSlides - visibleCards);
          if (slideIndex >= maxIndex) {
            slideIndex = 0; // loop back to start
          } else {
            slideIndex = Math.min(maxIndex, slideIndex + visibleCards);
          }
          updateCarousel();
        }, rotateSpeed);
      }
      function stopAutoRotate() {
        if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      }

      // Pause on hover, resume on leave
      wrapper.addEventListener("mouseenter", stopAutoRotate);
      wrapper.addEventListener("mouseleave", startAutoRotate);

      // Pause when user clicks arrows/dots (restart after delay)
      function userInteracted() {
        stopAutoRotate();
        // Resume after 2x the rotate speed
        setTimeout(startAutoRotate, rotateSpeed * 2);
      }
      prevBtn.addEventListener("click", userInteracted);
      nextBtn.addEventListener("click", userInteracted);
      dotsWrap.querySelectorAll(".rf-carousel__dot").forEach(function (dot) {
        dot.addEventListener("click", userInteracted);
      });

      startAutoRotate();

      // Recalculate on resize/orientation change
      window.addEventListener("resize", function () {
        slideIndex = 0;
        updateCarousel();
      });

      return wrapper;
    }

    // ── Compact card layout (expandable) ─────────────────
    function buildCompactCard(review) {
      var wrapper = el("div", { className: "rf-compact-wrapper" });
      var row = el("div", { className: "rf-compact-card" });

      var left = el("div", { className: "rf-compact-card__left" });
      left.appendChild(renderStars(review.rating, starColor, "14"));
      if (review.verifiedBuyer && contentType !== "recipe") {
        left.appendChild(el("span", { className: "rf-compact-card__verified", textContent: "\u2713" }));
      }
      row.appendChild(left);

      var mid = el("div", { className: "rf-compact-card__mid" });
      if (review.title) {
        mid.appendChild(el("span", { className: "rf-compact-card__title", textContent: review.title }));
      }
      var shortBody = review.body.length > 120 ? review.body.substring(0, 120) + "…" : review.body;
      mid.appendChild(el("span", { className: "rf-compact-card__body", textContent: shortBody }));
      row.appendChild(mid);

      var right = el("div", { className: "rf-compact-card__right" });
      right.appendChild(el("span", { className: "rf-compact-card__author", textContent: review.customerName }));
      right.appendChild(el("span", { className: "rf-compact-card__date", textContent: timeAgo(review.createdAt) }));
      row.appendChild(right);

      // Chevron indicator
      var chevron = el("span", { className: "rf-compact-card__chevron", innerHTML: "&#8250;" });
      row.appendChild(chevron);

      // Expanded detail panel (hidden by default)
      var detail = el("div", { className: "rf-compact-detail" });
      detail.style.display = "none";

      var detailBody = el("div", { className: "rf-compact-detail__body", textContent: review.body });
      detail.appendChild(detailBody);

      // Media in expanded view
      if (review.media && review.media.length > 0) {
        var mediaWrap = el("div", { className: "rf-review-card__media" });
        review.media.forEach(function (m) {
          if (m.type === "image") {
            var img = el("img", {
              className: "rf-review-card__img",
              src: m.url,
              alt: m.altText || "Review photo",
              loading: "lazy",
              onClick: function () {
                openLightbox(m.url, m.altText || "Review photo");
              }
            });
            mediaWrap.appendChild(img);
          }
        });
        detail.appendChild(mediaWrap);
      }

      // Helpful button in expanded view
      var detailFooter = el("div", { className: "rf-compact-detail__footer" });
      var voted = hasVotedHelpful(review.id);
      var helpfulCount = review.helpfulCount || 0;
      var helpfulBtn = el("button", {
        className: "rf-review-card__helpful" + (voted ? " rf-review-card__helpful--voted" : ""),
        textContent: "Helpful (" + helpfulCount + ")",
        onClick: function (e) {
          e.stopPropagation();
          if (hasVotedHelpful(review.id)) return;
          var fd = new FormData();
          fd.append("intent", "helpful");
          fd.append("reviewId", review.id);
          fetch(proxyUrl, { method: "POST", body: fd })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.success) {
                markHelpfulVoted(review.id);
                helpfulBtn.textContent = "Helpful (" + data.helpfulCount + ")";
                helpfulBtn.className = "rf-review-card__helpful rf-review-card__helpful--voted";
              }
            })
            .catch(function () {});
        }
      });
      if (voted) helpfulBtn.disabled = true;
      detailFooter.appendChild(helpfulBtn);

      // Admin reply in expanded view
      if (review.replyBody) {
        var reply = el("div", { className: "rf-review-card__reply" });
        reply.appendChild(el("div", { className: "rf-review-card__reply-label", textContent: "Store Response:" }));
        reply.appendChild(el("div", { textContent: review.replyBody }));
        detailFooter.appendChild(reply);
      }
      detail.appendChild(detailFooter);

      // Toggle expand/collapse on row click
      row.style.cursor = "pointer";
      row.addEventListener("click", function () {
        var isOpen = detail.style.display !== "none";
        detail.style.display = isOpen ? "none" : "block";
        wrapper.className = isOpen ? "rf-compact-wrapper" : "rf-compact-wrapper rf-compact-wrapper--open";
        chevron.className = isOpen ? "rf-compact-card__chevron" : "rf-compact-card__chevron rf-compact-card__chevron--open";
      });

      wrapper.appendChild(row);
      wrapper.appendChild(detail);
      return wrapper;
    }

    function toggleForm() {
      var fw = document.getElementById("rf-form-wrap");
      if (fw) fw.style.display = fw.style.display === "none" ? "block" : "none";
    }

    var selectedRating = 0;

    function buildForm() {
      var form = el("form", { className: "rf-form" });
      selectedFiles = [];

      // Star picker
      var starPicker = el("div", { className: "rf-form__star-picker" });
      starPicker.appendChild(el("label", { textContent: "Your Rating *" }));
      starsRow = el("div", { className: "rf-form__stars-row" });
      for (var i = 1; i <= 5; i++) {
        (function (rating) {
          var starBtn = el("button", {
            type: "button",
            className: "rf-form__star-btn",
            "data-rating": rating,
            onClick: function () {
              selectedRating = rating;
              starsRow.querySelectorAll(".rf-form__star-btn").forEach(function (btn, idx) {
                btn.innerHTML = "";
                btn.appendChild(starSVG(idx < rating, starColor));
              });
            }
          });
          starBtn.appendChild(starSVG(false, starColor));
          starsRow.appendChild(starBtn);
        })(i);
      }
      starPicker.appendChild(starsRow);
      form.appendChild(starPicker);

      // Name
      form.appendChild(el("label", { className: "rf-form__label", textContent: "Name *" }));
      form.appendChild(el("input", { type: "text", name: "customerName", className: "rf-form__input", required: "true", value: customerName, placeholder: "Your name" }));

      // Email
      form.appendChild(el("label", { className: "rf-form__label", textContent: "Email *" }));
      form.appendChild(el("input", { type: "email", name: "customerEmail", className: "rf-form__input", required: "true", value: customerEmail, placeholder: "your@email.com" }));

      // Title
      form.appendChild(el("label", { className: "rf-form__label", textContent: "Review Title" }));
      form.appendChild(el("input", { type: "text", name: "title", className: "rf-form__input", placeholder: "Summarize your experience" }));

      // Body
      form.appendChild(el("label", { className: "rf-form__label", textContent: "Your Review *" }));
      form.appendChild(el("textarea", { name: "body", className: "rf-form__textarea", required: "true", placeholder: "Tell others about your experience (minimum 10 characters)", rows: "4" }));

      // Photo upload is disabled unless the app proxy is configured to upload files.
      if (photoUploadEnabled) {
        var photoSection = el("div", { className: "rf-form__photo-section" });
        photoSection.appendChild(el("label", { className: "rf-form__label", textContent: "Add Photos (optional)" }));

        var photoInput = el("input", {
          type: "file",
          accept: "image/*",
          multiple: "true",
          className: "rf-form__photo-input",
          id: "rf-photo-input"
        });
        photoInput.style.display = "none";

        var uploadBtn = el("button", {
          type: "button",
          className: "rf-form__photo-upload-btn",
          textContent: "Choose Photos",
          onClick: function () { photoInput.click(); }
        });

        var previewContainer = el("div", { className: "rf-form__photos", id: "rf-photo-previews" });

        photoInput.addEventListener("change", function () {
          var files = photoInput.files;
          for (var fi = 0; fi < files.length && selectedFiles.length < 5; fi++) {
            selectedFiles.push(files[fi]);
          }
          renderPhotoPreviews(previewContainer);
          photoInput.value = "";
        });

        photoSection.appendChild(uploadBtn);
        photoSection.appendChild(photoInput);
        photoSection.appendChild(previewContainer);
        form.appendChild(photoSection);
      }

      // Honeypot (hidden anti-spam)
      var hp = el("input", { type: "text", name: "website", tabindex: "-1", autocomplete: "off" });
      hp.style.position = "absolute";
      hp.style.left = "-9999px";
      form.appendChild(hp);

      // Submit button
      var submitBtn = el("button", { type: "submit", className: "rf-form__submit", textContent: "Submit Review" });
      submitBtn.style.backgroundColor = starColor;
      form.appendChild(submitBtn);

      // Message area
      form.appendChild(el("div", { id: "rf-form-message", className: "rf-form__message" }));

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var msg = document.getElementById("rf-form-message");

        if (selectedRating === 0) {
          if (msg) { msg.textContent = "Please select a rating."; msg.style.color = "#dc2626"; }
          return;
        }

        var fd = new FormData(form);
        fd.append("shop", shop);
        fd.append("productId", productId);
        fd.append("productHandle", productHandle);
        fd.append("productTitle", productTitle);
        fd.append("contentType", contentType);
        fd.append("rating", selectedRating);

        // Append photo URLs as placeholders for now
        // In production, files would be uploaded to Shopify Files API first,
        // then URLs passed here. For the upload flow, we convert files to
        // data URLs and pass them as mediaUrl[] entries.
        // For real production, you'd upload to a file hosting endpoint first.
        if (photoUploadEnabled) {
          selectedFiles.forEach(function () {
            fd.append("mediaUrl[]", "");
          });
        }

        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting...";

        // If there are selected files, upload them first via a separate process.
        // For now, just submit the review text data.
        fetch(proxyUrl, { method: "POST", body: fd })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.success) {
              if (msg) { msg.textContent = data.message || "Thank you for your review!"; msg.style.color = "#16a34a"; }
              form.reset();
              selectedRating = 0;
              selectedFiles = [];
              var previews = document.getElementById("rf-photo-previews");
              if (previews) previews.innerHTML = "";
              starsRow.querySelectorAll(".rf-form__star-btn").forEach(function (btn) {
                btn.innerHTML = "";
                btn.appendChild(starSVG(false, starColor));
              });
              // Reload reviews after a delay
              setTimeout(function () { loadReviews(1); }, 2000);
            } else {
              if (msg) { msg.textContent = data.error || "Something went wrong."; msg.style.color = "#dc2626"; }
            }
          })
          .catch(function () {
            if (msg) { msg.textContent = "Network error. Please try again."; msg.style.color = "#dc2626"; }
          })
          .finally(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = "Submit Review";
          });
      });

      return form;
    }

    function renderPhotoPreviews(container) {
      container.innerHTML = "";
      selectedFiles.forEach(function (file, idx) {
        var preview = el("div", { className: "rf-form__photo-preview" });
        var img = el("img", { alt: "Preview " + (idx + 1) });
        var reader = new FileReader();
        reader.onload = function (e) {
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
        preview.appendChild(img);

        var removeBtn = el("button", {
          type: "button",
          className: "rf-form__photo-remove",
          textContent: "\u00D7",
          "aria-label": "Remove photo",
          onClick: function () {
            selectedFiles.splice(idx, 1);
            renderPhotoPreviews(container);
          }
        });
        preview.appendChild(removeBtn);
        container.appendChild(preview);
      });
    }

    function injectSEO(data) {
      if (!data.totalCount || data.totalCount === 0) return;

      var schemaType = contentType === "recipe" ? "Recipe" : "Product";
      var aggregateRating = {
        "@type": "AggregateRating",
        ratingValue: (data.averageRating || 0).toFixed(1),
        reviewCount: data.totalCount,
        bestRating: "5",
        worstRating: "1"
      };
      var reviews = (data.reviews || []).slice(0, 5).map(function (r) {
        return {
          "@type": "Review",
          author: { "@type": "Person", name: r.customerName },
          datePublished: r.createdAt ? r.createdAt.split("T")[0] : "",
          reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: "5", worstRating: "1" },
          reviewBody: r.body
        };
      });

      // Prefer merging the rating into the existing server-rendered schema node
      // (Recipe from recipe-article.liquid, Product from theme.liquid) so the
      // page has a single, complete node instead of a duplicate.
      var scripts = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].id === "rf-jsonld") continue;
        var parsed;
        try { parsed = JSON.parse(scripts[i].textContent); } catch (e) { continue; }
        var node = null;
        if (parsed && parsed["@graph"] && parsed["@graph"].length) {
          for (var g = 0; g < parsed["@graph"].length; g++) {
            if (parsed["@graph"][g]["@type"] === schemaType) { node = parsed["@graph"][g]; break; }
          }
        } else if (parsed && parsed["@type"] === schemaType) {
          node = parsed;
        }
        if (!node) continue;
        node.aggregateRating = aggregateRating;
        if (reviews.length) node.review = reviews;
        scripts[i].textContent = JSON.stringify(parsed);
        var stale = document.getElementById("rf-jsonld");
        if (stale) stale.remove();
        return;
      }

      // Fallback: no matching server node found — emit our own minimal node.
      var existing = document.getElementById("rf-jsonld");
      if (existing) existing.remove();
      var ld = {
        "@context": "https://schema.org",
        "@type": schemaType,
        name: productTitle,
        aggregateRating: aggregateRating
      };
      if (reviews.length) ld.review = reviews;
      var script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "rf-jsonld";
      script.textContent = JSON.stringify(ld);
      document.head.appendChild(script);
    }

    loadReviews(currentPage);
  }

  // ── Init ────────────────────────────────────────────
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initBadges();
      initWidget();
    });
  } else {
    initBadges();
    initWidget();
  }
})();
